import { InputNumber, Select } from 'antd'
import moment from 'moment'
import React from 'react'
import R from 'ramda'
const EventExcludes = ({
  EXEVENT,
  EX,
  setData,
  unitList = [],
  isStation = false,
  //   selStations = [],
  selUtilityStation = [],
  allUnits = [],
}) => {
  let finalUnitList = unitList
  if (isStation) {
    finalUnitList = R.compose(
      R.filter(u => selUtilityStation.includes(u.station))
    )(allUnits)
  }

  return (
    <React.Fragment>
      <Select
        style={{ width: '100%' }}
        value={EXEVENT && EXEVENT[EX] && EXEVENT[EX].unitid}
        onChange={unitid => {
          if (unitid === '[]') {
            setData({
              EXEVENT: {
                ...(EXEVENT || {}),
                [EX]: {},
              },
            })
          } else {
            const EX1 = {
              ...((EXEVENT || {})[EX] || {}),
              unitid: unitid,
              year: moment().format('YYYY'),
            }
            const EXEVENT2 = {
              ...(EXEVENT || {}),
              [EX]: EX1,
            }
            setData({ EXEVENT: EXEVENT2 })
          }
        }}
      >
        <Select.Option value="[]">[]</Select.Option>
        {(finalUnitList || []).map(u => (
          <Select.Option id={u.unitId} key={u.unitId} value={u.unitId}>
            {u.unitName}
          </Select.Option>
        ))}
      </Select>
      <InputNumber
        value={EXEVENT && EXEVENT[EX] && EXEVENT[EX].year}
        onChange={year => {
          const EX1 = {
            ...((EXEVENT || {})[EX] || {}),
            year,
          }
          const EXEVENT2 = {
            ...(EXEVENT || {}),
            [EX]: EX1,
          }
          setData({ EXEVENT: EXEVENT2 })
        }}
        style={{ width: '100%' }}
      />
      <InputNumber
        value={EXEVENT && EXEVENT[EX] && EXEVENT[EX].eventid}
        onChange={eventid => {
          const EX1 = {
            ...((EXEVENT || {})[EX] || {}),
            eventid,
          }
          const EXEVENT2 = {
            ...(EXEVENT || {}),
            [EX]: EX1,
          }
          setData({ EXEVENT: EXEVENT2 })
        }}
        style={{ width: '100%' }}
      />
    </React.Fragment>
  )
}

export default EventExcludes
